import { render, staticRenderFns } from "./KotaJayapura.vue?vue&type=template&id=47af9cc2"
import script from "./KotaJayapura.vue?vue&type=script&lang=js"
export * from "./KotaJayapura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports